import { View } from "@react-pdf/renderer";

import { getFullName } from "utils/common";
import { frontendLog } from "utils/debug.utils";

import { PdfDocumentStaffSignature } from "../footer-v2/pdf-document-staff-signature.type";
import SignatureSlot from "./signature-slot.component";
import SignedAtSlot from "./signed-at-slot.component";

type PdfDocumentFooterReportV3Props = {
  signedAtDate?: string;
  signatures: PdfDocumentStaffSignature[];
};

export default function PdfDocumentFooterReportV3({
  signedAtDate,
  signatures
}: PdfDocumentFooterReportV3Props) {
  const [providerSignature, cosignerSignature] = signatures;

  const providerFullName = providerSignature?.staffMember
    ? getFullName({
        firstName: providerSignature?.staffMember?.first_name || "",
        lastName: providerSignature?.staffMember?.last_name || "",
        title: providerSignature?.staffMember?.title,
        suffix: providerSignature?.staffMember?.suffix
      })
    : "";

  const cosignerFullName = cosignerSignature?.staffMember
    ? getFullName({
        firstName: cosignerSignature?.staffMember?.first_name || "",
        lastName: cosignerSignature?.staffMember?.last_name || "",
        title: cosignerSignature?.staffMember?.title,
        suffix: cosignerSignature?.staffMember?.suffix
      })
    : "";

  const licenseNumber = providerSignature?.licenseNumber;
  const cosignerLicenseNumber = cosignerSignature?.licenseNumber;

  frontendLog(["PdfDocumentFooterReportV3"], "components");

  return (
    <View
      wrap={false}
      style={{
        width: "100%",
        position: "absolute",
        bottom: 56,
        left: 50
      }}
    >
      <View
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "flex-end"
        }}
      >
        <SignedAtSlot signedAtDate={signedAtDate} />
        <View
          style={{
            width: "84%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end"
          }}
        >
          <SignatureSlot
            signedAtDate={signedAtDate}
            signatureImgUrl={providerSignature?.staffMember?.signature}
            signatureSize={providerSignature?.signatureSize}
            signatureLabel={providerSignature?.label}
            providerFullName={providerFullName}
            licenseNumber={licenseNumber}
            signaturesCount={
              cosignerSignature?.label && Boolean(cosignerFullName) ? 2 : 1
            }
          />
          {cosignerSignature?.label && Boolean(cosignerFullName) && (
            <SignatureSlot
              signedAtDate={signedAtDate}
              signatureImgUrl={cosignerSignature?.staffMember?.signature}
              signatureSize={cosignerSignature?.signatureSize}
              signatureLabel={cosignerSignature.label}
              providerFullName={cosignerFullName}
              licenseNumber={cosignerLicenseNumber}
            />
          )}
        </View>
      </View>
      <View
        style={{
          width: "100%",
          height: "3px",
          backgroundColor: "#381337",
          marginTop: "-7px"
        }}
      ></View>
    </View>
  );
}
